import React from 'react';
import {
    AlertTriangle, ArrowLeft, BarChart3, Building2, Calendar, Check, CheckCircle,
    CheckCircle2, ChevronDown, ChevronRight, ChevronUp, CircleAlert, ClipboardCheck,
    Clock, Columns, Database, Download, FileSpreadsheet, FileText, Filter,
    Globe, History, Home, Inbox, Info, Key, List, Lock, LogOut, MessageSquare,
    PanelRightOpen, PieChart, PlayCircle, Plug, Plus, RefreshCw,
    ScrollText, Search, SearchX, Settings, ShieldCheck, SlidersHorizontal,
    Table, TrendingDown, TrendingUp, Undo2, UploadCloud, UserCog, UserPlus,
    Users, WifiOff, Wrench, X,
} from 'lucide-react';

const ICON_MAP = {
    'alert-triangle': AlertTriangle, 'arrow-left': ArrowLeft,
    'bar-chart-3': BarChart3, 'building-2': Building2, 'calendar': Calendar,
    'check': Check, 'check-circle': CheckCircle, 'check-circle-2': CheckCircle2,
    'chevron-down': ChevronDown,
    'chevron-right': ChevronRight, 'chevron-up': ChevronUp,
    'circle-alert': CircleAlert, 'clipboard-check': ClipboardCheck,
    'clock': Clock, 'columns': Columns, 'database': Database,
    'download': Download, 'file-spreadsheet': FileSpreadsheet,
    'file-text': FileText, 'filter': Filter, 'globe': Globe,
    'history': History, 'home': Home, 'inbox': Inbox, 'info': Info, 'key': Key, 'list': List,
    'lock': Lock, 'log-out': LogOut, 'message-square': MessageSquare,
    'panel-right-open': PanelRightOpen, 'pie-chart': PieChart,
    'play-circle': PlayCircle, 'plug': Plug, 'plus': Plus,
    'refresh-cw': RefreshCw, 'scroll-text': ScrollText, 'search': Search,
    'search-x': SearchX, 'settings': Settings, 'shield-check': ShieldCheck,
    'sliders-horizontal': SlidersHorizontal, 'table': Table,
    'trending-down': TrendingDown, 'trending-up': TrendingUp,
    'undo-2': Undo2, 'upload-cloud': UploadCloud, 'user-cog': UserCog, 'user-plus': UserPlus,
    'users': Users, 'wifi-off': WifiOff, 'wrench': Wrench, 'x': X,
};

export default function Icon({ name, className }) {
    const LucideIcon = ICON_MAP[name] || CircleAlert;
    return <LucideIcon className={className} />;
}
